import { render } from "./EditHoliday.vue?vue&type=template&id=1af91fd8&scoped=true"
import script from "./EditHoliday.vue?vue&type=script&lang=js"
export * from "./EditHoliday.vue?vue&type=script&lang=js"

import "./holiday.scss?vue&type=style&index=0&id=1af91fd8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af91fd8"]])

export default __exports__